var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-pane-inner" }, [
    _c("div", { staticClass: "go-add-input" }, [
      _c(
        "div",
        {
          staticClass: "go-form-group go-form-group-search",
          class: { notAllowSearch: _vm.isLoading },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.queries,
                expression: "queries",
              },
            ],
            staticClass: "go-form-control",
            attrs: {
              disabled: _vm.isLoading,
              readonly: _vm.isLoading,
              maxlength: "2048",
              placeholder: _vm.$t(
                "popupAddReference.searchTab.placeHolderSearch"
              ),
              type: "search",
            },
            domProps: { value: _vm.queries },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.searchData()
              },
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.queries = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn go-btn-icon",
              class: { notAllowSearch: _vm.isLoading },
              attrs: { disabled: _vm.isLoading, type: "submit" },
              on: {
                click: function ($event) {
                  return _vm.searchData()
                },
              },
            },
            [_c("i", { staticClass: "go-icon-20 go-icon-search" })]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      {
        staticClass: "nav go-tab-pills",
        class: { notAllowSearch: _vm.isLoading },
      },
      [
        _c("li", { staticClass: "go-tab-item" }, [
          _c(
            "a",
            {
              staticClass: "go-tab-link active",
              attrs: { "data-target": "#go-search-all", "data-toggle": "tab" },
              on: {
                click: function ($event) {
                  return _vm.onClickTab("ALL", 1, true, true)
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "popupAddReference.searchTab.childTabOfSearchTitle.all"
                    )
                  ) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "go-tab-item" }, [
          _c(
            "a",
            {
              staticClass: "go-tab-link",
              attrs: {
                "data-target": "#go-search-goover",
                "data-toggle": "tab",
              },
              on: {
                click: function ($event) {
                  return _vm.onClickTab("GOOVER", 2, true, false)
                },
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "popupAddReference.searchTab.childTabOfSearchTitle.goover"
                  )
                )
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "go-tab-item" }, [
          _c(
            "a",
            {
              staticClass: "go-tab-link",
              attrs: { "data-target": "#go-search-web", "data-toggle": "tab" },
              on: {
                click: function ($event) {
                  return _vm.onClickTab("WEB", 3, true, false)
                },
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "popupAddReference.searchTab.childTabOfSearchTitle.website"
                  )
                )
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "go-tab-item" }, [
          _c(
            "a",
            {
              staticClass: "go-tab-link",
              attrs: { "data-target": "#go-search-news", "data-toggle": "tab" },
              on: {
                click: function ($event) {
                  return _vm.onClickTab("NEWS", 4, true, false)
                },
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "popupAddReference.searchTab.childTabOfSearchTitle.news"
                  )
                )
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "go-tab-item" }, [
          _c(
            "a",
            {
              staticClass: "go-tab-link",
              attrs: {
                "data-target": "#go-search-video",
                "data-toggle": "tab",
              },
              on: {
                click: function ($event) {
                  return _vm.onClickTab("VIDEO", 5, true, false)
                },
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "popupAddReference.searchTab.childTabOfSearchTitle.video"
                  )
                )
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "go-tab-item" }, [
          _c(
            "a",
            {
              staticClass: "go-tab-link",
              attrs: {
                "data-target": "#go-search-document",
                "data-toggle": "tab",
              },
              on: {
                click: function ($event) {
                  return _vm.onClickTab("searchFileType", 6, true, false)
                },
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "popupAddReference.searchTab.childTabOfSearchTitle.document"
                  )
                )
              ),
            ]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "tab-content tab-content-sub" }, [
      _c(
        "div",
        {
          staticClass: "tab-pane fade show active",
          attrs: { id: "go-search-all" },
        },
        [
          _c("div", { staticClass: "tab-pane-inner" }, [
            _c(
              "div",
              { staticClass: "go-list-wrap" },
              [
                _c(
                  "vue-custom-scrollbar",
                  {
                    staticClass:
                      "go-list-inner overflow-y-scroll customScroll csScrollPosition ps",
                    attrs: { settings: _vm.scrollSettings },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "auto",
                          height: "auto",
                        },
                      },
                      [
                        _vm.gooverData !== null && _vm.gooverData.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "go-section go-section-search-sm",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "go-section-header" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "go-section-title" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "popupAddReference.searchTab.childTabOfSearchTitle.goover"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-section-body" }, [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "go-card-sub-list go-card-resource",
                                    },
                                    _vm._l(
                                      _vm.gooverData,
                                      function (refItem, index) {
                                        return _c("ref-item", {
                                          key: refItem.id + index,
                                          attrs: {
                                            "form-model": refItem,
                                            "is-has-link": true,
                                            "remove-able": false,
                                          },
                                          on: {
                                            openLink: function ($event) {
                                              return _vm.openNewTab(
                                                refItem.link || refItem.url
                                              )
                                            },
                                            toggleBookmark: function ($event) {
                                              return _vm.selectAddingReferenceDocument(
                                                refItem
                                              )
                                            },
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "go-section-footer" },
                                  [
                                    _vm.isLoadMoreGoover
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn go-btn-default",
                                            class: {
                                              notAllowSearch: _vm.isLoading,
                                            },
                                            attrs: {
                                              disabled: _vm.isLoading,
                                              type: "button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.loadMoreSearchResultByNextPage(
                                                  "goover"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "popupAddReference.searchTab.loadMoreText"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.webData !== null && _vm.webData.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "go-section go-section-search-sm",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "go-section-header" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "go-section-title" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "popupAddReference.searchTab.childTabOfSearchTitle.website"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-section-body" }, [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "go-card-sub-list go-card-resource",
                                    },
                                    _vm._l(
                                      _vm.webData,
                                      function (refItem, index) {
                                        return _c("ref-item", {
                                          key: refItem.id + index,
                                          attrs: {
                                            "form-model": refItem,
                                            "is-has-link": true,
                                            "remove-able": false,
                                          },
                                          on: {
                                            openLink: function ($event) {
                                              return _vm.openNewTab(
                                                refItem.link || refItem.url
                                              )
                                            },
                                            toggleBookmark: function ($event) {
                                              return _vm.selectAddingReferenceDocument(
                                                refItem
                                              )
                                            },
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "go-section-footer" },
                                  [
                                    _vm.isLoadMoreWebsite
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn go-btn-default",
                                            class: {
                                              notAllowSearch: _vm.isLoading,
                                            },
                                            attrs: {
                                              disabled: _vm.isLoading,
                                              type: "button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.loadMoreSearchResultByNextPage(
                                                  "web"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "popupAddReference.searchTab.loadMoreText"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.newsData !== null && _vm.newsData.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "go-section go-section-search-sm",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "go-section-header" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "go-section-title" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "popupAddReference.searchTab.childTabOfSearchTitle.news"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-section-body" }, [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "go-card-sub-list go-card-resource",
                                    },
                                    _vm._l(
                                      _vm.newsData,
                                      function (refItem, index) {
                                        return _c("ref-item", {
                                          key: refItem.id + index,
                                          attrs: {
                                            "form-model": refItem,
                                            "is-has-link": true,
                                            "remove-able": false,
                                          },
                                          on: {
                                            openLink: function ($event) {
                                              return _vm.openNewTab(
                                                refItem.link || refItem.url
                                              )
                                            },
                                            toggleBookmark: function ($event) {
                                              return _vm.selectAddingReferenceDocument(
                                                refItem
                                              )
                                            },
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "go-section-footer" },
                                  [
                                    _vm.isLoadMoreNews
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn go-btn-default",
                                            class: {
                                              notAllowSearch: _vm.isLoading,
                                            },
                                            attrs: {
                                              disabled: _vm.isLoading,
                                              type: "button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.loadMoreSearchResultByNextPage(
                                                  "news"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "popupAddReference.searchTab.loadMoreText"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.videoData !== null && _vm.videoData.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "go-section go-section-search-sm",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "go-section-header" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "go-section-title" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "popupAddReference.searchTab.childTabOfSearchTitle.video"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-section-body" }, [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "go-card-sub-list go-card-resource",
                                    },
                                    _vm._l(
                                      _vm.videoData,
                                      function (refItem, index) {
                                        return _c("ref-item", {
                                          key: refItem.id + index,
                                          attrs: {
                                            "form-model": refItem,
                                            "is-has-link": true,
                                            "remove-able": false,
                                          },
                                          on: {
                                            openLink: function ($event) {
                                              return _vm.openNewTab(
                                                refItem.link || refItem.url
                                              )
                                            },
                                            toggleBookmark: function ($event) {
                                              return _vm.selectAddingReferenceDocument(
                                                refItem
                                              )
                                            },
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "go-section-footer" },
                                  [
                                    _vm.isLoadMoreVideo
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn go-btn-default",
                                            class: {
                                              notAllowSearch: _vm.isLoading,
                                            },
                                            attrs: {
                                              disabled: _vm.isLoading,
                                              type: "button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.loadMoreSearchResultByNextPage(
                                                  "video"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "popupAddReference.searchTab.loadMoreText"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.documentData !== null && _vm.documentData.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "go-section go-section-search-sm",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "go-section-header" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "go-section-title" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "popupAddReference.searchTab.childTabOfSearchTitle.document"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-section-body" }, [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "go-card-sub-list go-card-resource",
                                    },
                                    _vm._l(
                                      _vm.documentData,
                                      function (refItem, index) {
                                        return _c("ref-item", {
                                          key: refItem.id + index,
                                          attrs: {
                                            "form-model": refItem,
                                            "is-has-link": true,
                                            "remove-able": false,
                                          },
                                          on: {
                                            openLink: function ($event) {
                                              return _vm.openNewTab(
                                                refItem.link || refItem.url
                                              )
                                            },
                                            toggleBookmark: function ($event) {
                                              return _vm.selectAddingReferenceDocument(
                                                refItem
                                              )
                                            },
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "go-section-footer" },
                                  [
                                    _vm.isLoadMoreDocument
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn go-btn-default",
                                            class: {
                                              notAllowSearch: _vm.isLoading,
                                            },
                                            attrs: {
                                              disabled: _vm.isLoading,
                                              type: "button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.loadMoreSearchResultByNextPage(
                                                  "document"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "popupAddReference.searchTab.loadMoreText"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShowNoResultAll &&
                        !_vm.isFirstTimesSearch &&
                        !_vm.isLoading
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  height: "250px",
                                  width: "100%",
                                  "text-align": "center",
                                  "align-items": "center",
                                  "justify-content": "center",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "margin-top": "150px",
                                      "font-size": "0.75rem",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "popupAddReference.searchTab.noResult"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tab-pane fade", attrs: { id: "go-search-goover" } },
        [
          _c("div", { staticClass: "tab-pane-inner" }, [
            _c(
              "div",
              { staticClass: "go-list-wrap" },
              [
                _c(
                  "vue-custom-scrollbar",
                  {
                    staticClass:
                      "go-list-inner overflow-y-scroll customScroll csScrollPosition ps",
                    attrs: { settings: _vm.scrollSettings },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "auto",
                          height: "auto",
                        },
                      },
                      [
                        _vm.gooverData !== null && _vm.gooverData.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "go-section go-section-search-sm",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "go-section-header" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "go-section-title" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "popupAddReference.searchTab.childTabOfSearchTitle.goover"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-section-body" }, [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "go-card-sub-list go-card-resource",
                                    },
                                    _vm._l(
                                      _vm.gooverData,
                                      function (refItem, index) {
                                        return _c("ref-item", {
                                          key: refItem.id + index,
                                          attrs: {
                                            "form-model": refItem,
                                            "is-has-link": true,
                                            "remove-able": false,
                                          },
                                          on: {
                                            openLink: function ($event) {
                                              return _vm.openNewTab(
                                                refItem.link || refItem.url
                                              )
                                            },
                                            toggleBookmark: function ($event) {
                                              return _vm.selectAddingReferenceDocument(
                                                refItem
                                              )
                                            },
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "go-section-footer" },
                                  [
                                    _vm.isLoadMoreGoover
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn go-btn-default",
                                            class: {
                                              notAllowSearch: _vm.isLoading,
                                            },
                                            attrs: {
                                              disabled: _vm.isLoading,
                                              type: "button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.loadMoreSearchResultByNextPage(
                                                  "goover"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "popupAddReference.searchTab.loadMoreText"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (_vm.gooverData === null ||
                          _vm.gooverData.length === 0) &&
                        !_vm.isFirstTimesSearch &&
                        !_vm.isLoading
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  height: "250px",
                                  width: "100%",
                                  "text-align": "center",
                                  "align-items": "center",
                                  "justify-content": "center",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "margin-top": "150px",
                                      "font-size": "0.75rem",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "popupAddReference.searchTab.noResult"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tab-pane fade", attrs: { id: "go-search-web" } },
        [
          _c("div", { staticClass: "tab-pane-inner" }, [
            _c(
              "div",
              { staticClass: "go-list-wrap" },
              [
                _c(
                  "vue-custom-scrollbar",
                  {
                    staticClass:
                      "go-list-inner overflow-y-scroll customScroll csScrollPosition ps",
                    attrs: { settings: _vm.scrollSettings },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "auto",
                          height: "auto",
                        },
                      },
                      [
                        _vm.webData !== null && _vm.webData.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "go-section go-section-search-sm",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "go-section-header" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "go-section-title" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "popupAddReference.searchTab.childTabOfSearchTitle.website"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-section-body" }, [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "go-card-sub-list go-card-resource",
                                    },
                                    _vm._l(
                                      _vm.webData,
                                      function (refItem, index) {
                                        return _c("ref-item", {
                                          key: refItem.id + index,
                                          attrs: {
                                            "form-model": refItem,
                                            "is-has-link": true,
                                            "remove-able": false,
                                          },
                                          on: {
                                            openLink: function ($event) {
                                              return _vm.openNewTab(
                                                refItem.link || refItem.url
                                              )
                                            },
                                            toggleBookmark: function ($event) {
                                              return _vm.selectAddingReferenceDocument(
                                                refItem
                                              )
                                            },
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "go-section-footer" },
                                  [
                                    _vm.isLoadMoreWebsite
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn go-btn-default",
                                            class: {
                                              notAllowSearch: _vm.isLoading,
                                            },
                                            attrs: {
                                              disabled: _vm.isLoading,
                                              type: "button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.loadMoreSearchResultByNextPage(
                                                  "web"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "popupAddReference.searchTab.loadMoreText"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (_vm.webData === null || _vm.webData.length === 0) &&
                        !_vm.isFirstTimesSearch &&
                        !_vm.isLoading
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  height: "250px",
                                  width: "100%",
                                  "text-align": "center",
                                  "align-items": "center",
                                  "justify-content": "center",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "margin-top": "150px",
                                      "font-size": "0.75rem",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "popupAddReference.searchTab.noResult"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tab-pane fade", attrs: { id: "go-search-news" } },
        [
          _c("div", { staticClass: "tab-pane-inner" }, [
            _c(
              "div",
              { staticClass: "go-list-wrap" },
              [
                _c(
                  "vue-custom-scrollbar",
                  {
                    staticClass:
                      "go-list-inner overflow-y-scroll customScroll csScrollPosition ps",
                    attrs: { settings: _vm.scrollSettings },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "auto",
                          height: "auto",
                        },
                      },
                      [
                        _vm.newsData !== null && _vm.newsData.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "go-section go-section-search-sm",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "go-section-header" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "go-section-title" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "popupAddReference.searchTab.childTabOfSearchTitle.news"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-section-body" }, [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "go-card-sub-list go-card-resource",
                                    },
                                    _vm._l(
                                      _vm.newsData,
                                      function (refItem, index) {
                                        return _c("ref-item", {
                                          key: refItem.id + index,
                                          attrs: {
                                            "form-model": refItem,
                                            "is-has-link": true,
                                            "remove-able": false,
                                          },
                                          on: {
                                            openLink: function ($event) {
                                              return _vm.openNewTab(
                                                refItem.link || refItem.url
                                              )
                                            },
                                            toggleBookmark: function ($event) {
                                              return _vm.selectAddingReferenceDocument(
                                                refItem
                                              )
                                            },
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "go-section-footer" },
                                  [
                                    _vm.isLoadMoreNews
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn go-btn-default",
                                            class: {
                                              notAllowSearch: _vm.isLoading,
                                            },
                                            attrs: {
                                              disabled: _vm.isLoading,
                                              type: "button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.loadMoreSearchResultByNextPage(
                                                  "news"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "popupAddReference.searchTab.loadMoreText"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (_vm.newsData === null || _vm.newsData.length === 0) &&
                        !_vm.isFirstTimesSearch &&
                        !_vm.isLoading
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  height: "250px",
                                  width: "100%",
                                  "text-align": "center",
                                  "align-items": "center",
                                  "justify-content": "center",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "margin-top": "150px",
                                      "font-size": "0.75rem",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "popupAddReference.searchTab.noResult"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tab-pane fade", attrs: { id: "go-search-video" } },
        [
          _c("div", { staticClass: "tab-pane-inner" }, [
            _c(
              "div",
              { staticClass: "go-list-wrap" },
              [
                _c(
                  "vue-custom-scrollbar",
                  {
                    staticClass:
                      "go-list-inner overflow-y-scroll customScroll csScrollPosition ps",
                    attrs: { settings: _vm.scrollSettings },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "auto",
                          height: "auto",
                        },
                      },
                      [
                        _vm.videoData !== null && _vm.videoData.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "go-section go-section-search-sm",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "go-section-header" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "go-section-title" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "popupAddReference.searchTab.childTabOfSearchTitle.video"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-section-body" }, [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "go-card-sub-list go-card-resource",
                                    },
                                    _vm._l(
                                      _vm.videoData,
                                      function (refItem, index) {
                                        return _c("ref-item", {
                                          key: refItem.id + index,
                                          attrs: {
                                            "form-model": refItem,
                                            "is-has-link": true,
                                            "remove-able": false,
                                          },
                                          on: {
                                            openLink: function ($event) {
                                              return _vm.openNewTab(
                                                refItem.link || refItem.url
                                              )
                                            },
                                            toggleBookmark: function ($event) {
                                              return _vm.selectAddingReferenceDocument(
                                                refItem
                                              )
                                            },
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "go-section-footer" },
                                  [
                                    _vm.isLoadMoreVideo
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn go-btn-default",
                                            class: {
                                              notAllowSearch: _vm.isLoading,
                                            },
                                            attrs: {
                                              disabled: _vm.isLoading,
                                              type: "button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.loadMoreSearchResultByNextPage(
                                                  "video"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "popupAddReference.searchTab.loadMoreText"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (_vm.videoData === null ||
                          _vm.videoData.length === 0) &&
                        !_vm.isFirstTimesSearch &&
                        !_vm.isLoading
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  height: "250px",
                                  width: "100%",
                                  "text-align": "center",
                                  "align-items": "center",
                                  "justify-content": "center",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "margin-top": "150px",
                                      "font-size": "0.75rem",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "popupAddReference.searchTab.noResult"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tab-pane fade", attrs: { id: "go-search-document" } },
        [
          _c("div", { staticClass: "tab-pane-inner" }, [
            _c(
              "div",
              { staticClass: "go-list-wrap" },
              [
                _c(
                  "vue-custom-scrollbar",
                  {
                    staticClass:
                      "go-list-inner overflow-y-scroll customScroll csScrollPosition ps",
                    attrs: { settings: _vm.scrollSettings },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "auto",
                          height: "auto",
                        },
                      },
                      [
                        _vm.documentData !== null && _vm.documentData.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "go-section go-section-search-sm",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "go-section-header" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "go-section-title" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "popupAddReference.searchTab.childTabOfSearchTitle.document"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-section-body" }, [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "go-card-sub-list go-card-resource",
                                    },
                                    _vm._l(
                                      _vm.documentData,
                                      function (refItem, index) {
                                        return _c("ref-item", {
                                          key: refItem.id + index,
                                          attrs: {
                                            "form-model": refItem,
                                            "is-has-link": true,
                                            "remove-able": false,
                                          },
                                          on: {
                                            openLink: function ($event) {
                                              return _vm.openNewTab(
                                                refItem.link || refItem.url
                                              )
                                            },
                                            toggleBookmark: function ($event) {
                                              return _vm.selectAddingReferenceDocument(
                                                refItem
                                              )
                                            },
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "go-section-footer" },
                                  [
                                    _vm.isLoadMoreDocument
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn go-btn-default",
                                            class: {
                                              notAllowSearch: _vm.isLoading,
                                            },
                                            attrs: {
                                              disabled: _vm.isLoading,
                                              type: "button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.loadMoreSearchResultByNextPage(
                                                  "document"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "popupAddReference.searchTab.loadMoreText"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (_vm.documentData === null ||
                          _vm.documentData.length === 0) &&
                        !_vm.isFirstTimesSearch &&
                        !_vm.isLoading
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  height: "250px",
                                  width: "100%",
                                  "text-align": "center",
                                  "align-items": "center",
                                  "justify-content": "center",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "margin-top": "150px",
                                      "font-size": "0.75rem",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "popupAddReference.searchTab.noResult"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }